import {classNames, IconNames, MaterialIcon} from "@variocube/cube-ui";
import * as React from "react";
import {stylesheet} from "typestyle";

interface MainButtonProps {
    iconSrc?: string;
    materialIcon?: IconNames;
    label: string;
    onClick: () => void;
    className?: string;
}

export function MainButton({materialIcon, iconSrc, label, onClick, className}: MainButtonProps) {
    return (
        <div className={classNames(styles.mainButton, className)} onClick={onClick}>
            <div className={styles.icon}>
            {iconSrc && (
                <img alt={label} src={iconSrc} className={styles.iconImg}/>
            )}
            {materialIcon && (
                <MaterialIcon icon={materialIcon} className={styles.materialIcon}/>
            )}
            </div>
            <div className={styles.mainButtonText}>{label}</div>
        </div>
    )
}

const styles = stylesheet({
    mainButton: {
        backgroundColor: "var(--color-primary)",
        fontSize: "2em",
        display: "flex",
        flexFlow: "column nowrap",
        justifyContent: "center",
        alignItems: "center",
        padding: "0.75em 1.5em"
    },
    icon: {
        marginBottom: "0.75em"
    },
    iconImg: {
        display: "block",
        width: "100%",
    },
    materialIcon: {
        fontSize: "2em",
        display: "block",
        textAlign: "center",
        lineHeight: 1,
    },
    mainButtonText: {
        textAlign: "center",
        fontWeight: 500,
    },
})